/* My Garage Feature - Non Collection Pages */
function parseCookieString(e) {
  return e.split(";").reduce(function (e, t) {
    let i = t.split("=");
    return (e[i.shift().trim()] = decodeURI(i.join("="))), e;
  }, {});
}
function triggerRefreshLinks() {
  let e = parseCookieString(document.cookie);
  if (
    document.cookie
      .split(";")
      .some((e) => e.trim().startsWith("myActiveGarage="))
  ) {
    let t = JSON.parse(e.myActiveGarage || "[]"),
      i = document.querySelectorAll(
        '.header__linklist-item[data-item-title="SHOP BY CATEGORY"] a, .header__linklist-item[data-item-title="SHOP BY PRODUCTS"] a, .vehicle-filter-links'
      ),
      r = new URL(window.location.href),
      a = r.searchParams;
    var l =
      "?filter.p.m.vehicle.compatibility=" +
      (t = t.toString().replace(/ /g, "+"));
    a.forEach((e, t) => {
      ("filter.v.price.lte" == t ||
        "filter.v.price.gte" == t ||
        "sort_by" == t ||
        "filter.p.tag" == t) &&
        (l = l + "&" + t + "=" + e);
    }),
      (i ?? []).forEach((e) => {
        let t = new URL(e.href);
        (t.search = ""), (e.href = t.href + l);
      });
  }
}
/* END My Garage Feature - Non Collection Pages */
